import { createFeature, createReducer, on } from '@ngrx/store';
import { User } from 'thkee-common';
import { AuthActions } from './auth.actions';

export interface AuthInfo {
  id: number;
  fullname: string;
  language?: string;
  is_instructor?: boolean;
  instructor_id?: number;
  is_active?: boolean;
  photo_url: string;
  cart_item_count?: number;
  email: string;
  cart:
    | {
        id?: number;
        items?: string[];
      }
    | undefined;
}

export type AuthState = {
  user: User | undefined;
  isAuthenticated: boolean | undefined;
  cart:
    | {
        id?: number;
        items?: string[];
      }
    | undefined;
  courses: string[];
  authInfo: AuthInfo;
};
export const initialAuthState: AuthState = {
  isAuthenticated: undefined,
  user: undefined,
  cart: {},
  courses: [],
  authInfo: {
    cart: undefined,
    id: 0,
    fullname: '',
    photo_url: '',
    email: '',
  },
};

export const authReducer = createReducer(
  initialAuthState,
  on(AuthActions.loginSuccess, (state) => ({
    ...state,
    isAuthenticated: true,
  })),
  on(AuthActions.userLoaded, (state, { user }) => {
    const userState = {
      ...state,
      isAuthenticated: true,
      userId: user.id,
      user: user,
      cart: user.cart,
      courses: user.stats?.classes ? user.stats?.classes : [],
    };
    return userState;
  }),
  on(AuthActions.updateUserSuccess, (state, { user }) => {
    return {
      ...state,
      authInfo: { ...state.authInfo, photo_url: user.photo_url ?? '' },
      user: { ...state.user, ...(user as any) },
    };
  }),
  on(AuthActions.logout, () => ({ ...initialAuthState, user: undefined, isAuthenticated: false })),
  on(AuthActions.useAsGuest, (state) => ({ ...state, user: undefined, isAuthenticated: false })),
  on(AuthActions.signupInstructorSuccess, (state) => ({
    ...state,
    user: { ...state.user!, is_instructor: true },
  })),
  on(AuthActions.userAuthInfoLoaded, (state, { authInfo }) => ({
    ...state,
    isAuthenticated: true,
    cart: authInfo.cart,
    authInfo: authInfo,
  })),
  on(AuthActions.userAuthInfoClean, (state) => {
    const authState = {
      ...state,
      authInfo: {
        ...state.authInfo,
        cart: {},
        cart_item_count: 0,
      },
    };
    return authState;
  })
);

export const authFeature = createFeature({
  name: 'auth',
  reducer: authReducer,
});
